import AOS from 'aos';
//import 'aos/dist/aos.css'; // You can also use <link> for styles


// ..
jQuery(document).ready(function ($) {
    AOS.init();


});


/* MOBILE PRODUCTS CAROUSEL */

jQuery(document).ready(function ($) {
    var viewport = $(window).width();
    if (viewport <= 767) {
        $('.up-sells.upsells ul.products').addClass('geeg_mobile_products_carousel');
        $('.related.products ul.products').addClass('geeg_mobile_products_carousel');

    }

/*
    $('.geeg_mobile_products_carousel').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,


    });
*/


    $(document).ready(function(){
        $("#geeg_product_list_view_btn_list").click(function(){
            $(".products li.product").addClass("geeg_product_list_view");
        });
        $("#geeg_product_list_view_btn_column").click(function(){
            $(".products li.product").removeClass("geeg_product_list_view");
        });





    });

});
